import { Box, Button, TextField } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import GlobalDialogContent from '../GlobalDialogContent';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../redux/store';
import { closeDialog } from '../../../redux/reducer/dialogSlice';
import { UpdateBeneficiaryStatusService, UpdateUserStatusService } from '../../../utils/services/registration/donor-registration.service';
import { showSnackbar } from '../../../redux/reducer/snackbarSlice';
import { setModuleRefresh } from '../../../redux/reducer/registration/RefreshSlice';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Capitalize } from '../../../utils/utils';

export default function BenificiaryApprovedReject() {
    const dispatch = useDispatch();
    const { status, payload } = useSelector((state: RootState) => state.dialog);
    const uuid = payload?.uuid;
    const registrationType = payload?.registrationType;
    const [searchParams] = useSearchParams();
    const type = searchParams.get("type");
    const [selectedRoleId, setSelectedRoleId] = useState<string>('');
    const [roleList, setRoleList] = useState<any>([]);
    const authUser = useSelector((state: RootState) => state.authUser);
    const [loading, setloading] = useState(false);

    const validationSchema = Yup.object().shape({
        remarks: Yup.string().required('remarks are required'),
        role: Yup.lazy((value) => {
            return payload?.registrationType === "government_user" && status !== "Compliance" && status !== "Rejected"
                ? Yup.string().required('Role is required')
                : Yup.string().notRequired();
        }),
    });


    return (
        <GlobalDialogContent
            dialogBody={
                <Formik
                    initialValues={{ remarks: '', approved_amount: '' }}
                    validationSchema={validationSchema}
                    onSubmit={async (values, { setSubmitting }) => {
                        setloading(true);
                        const submitPayload = {
                            uuid: uuid,
                            status: payload.approvalType,
                            ...(payload.approvalType === 'approved' ? { approved_amount: Number(values.approved_amount) } : {}),
                            remarks: values.remarks
                        };
                        const response = await UpdateBeneficiaryStatusService(submitPayload);
                        const { code, message } = response;
                        if (code === 200) {
                            dispatch(closeDialog());
                            dispatch(setModuleRefresh({ moduleName: 'user_details', refresh: true }));
                            dispatch(showSnackbar({ type: 'success', message: message || 'Status Updated Successfully' }));
                        } else {
                            setloading(false);
                            dispatch(showSnackbar({ type: 'error', message: message || 'Something went wrong, please try again' }));
                        }
                    }}
                >
                    {({ errors, touched, isSubmitting, setFieldValue }) => (
                        <Form id="user-approval-form">
                            {payload.approvalType === 'approved' &&
                            <Box mb={2}>
                                <Field
                                    as={TextField}
                                    name="approved_amount"
                                    label="Approved Amount *"
                                    fullWidth
                                    size="small"
                                    multiline
                                    error={touched.approved_amount && Boolean(errors.approved_amount)}
                                    helperText={touched.approved_amount && errors.approved_amount}
                                />
                            </Box>}
                            <Box mb={2}>
                                <Field
                                    as={TextField}
                                    name="remarks"
                                    label="Remarks *"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    error={touched.remarks && Boolean(errors.remarks)}
                                    helperText={touched.remarks && errors.remarks}
                                />
                            </Box>
                        </Form>
                    )}
                </Formik>
            }
            dialogFooter={
                <Button
                    type="submit"
                    variant="contained"
                    color={status === 'approved' ? 'success' : status === 'rejected' ? "error" : "error"}
                    form="user-approval-form"
                    disabled={loading}
                >
                    {loading ? 'Loading...' : Capitalize(status)}
                </Button>
            }
        />
    );
}